const MODEL_DATA_UPDATES_BASE_PATH = '/model-data-updates';
const MODEL_DATA_UPDATES_SECTIONS = {
    manageUpdates: 'manage-updates',
    sendUpdateRequests: 'send-update-requests',
};
const DEFAULT_MODEL_DATA_UPDATES_SECTION = MODEL_DATA_UPDATES_SECTIONS.manageUpdates;
const LEGACY_MODEL_DATA_UPDATES_SECTION_ALIASES = {
    'massive-request': MODEL_DATA_UPDATES_SECTIONS.sendUpdateRequests,
};
const MODEL_DATA_UPDATES_PATH = `${MODEL_DATA_UPDATES_BASE_PATH}/${DEFAULT_MODEL_DATA_UPDATES_SECTION}`;

const normalizeModelDataUpdatesParam = (value) => {
    if (value == null) {
        return '';
    }

    const normalizedValue = `${value}`.trim();
    return normalizedValue !== '' ? normalizedValue : '';
};

const normalizeModelDataUpdatesSection = (section) => {
    const normalizedSection = normalizeModelDataUpdatesParam(section).toLowerCase();

    if (!normalizedSection) {
        return DEFAULT_MODEL_DATA_UPDATES_SECTION;
    }

    if (Object.values(MODEL_DATA_UPDATES_SECTIONS).includes(normalizedSection)) {
        return normalizedSection;
    }

    return LEGACY_MODEL_DATA_UPDATES_SECTION_ALIASES[normalizedSection] || DEFAULT_MODEL_DATA_UPDATES_SECTION;
};

const buildModelDataUpdatesSectionPath = (section) =>
    `${MODEL_DATA_UPDATES_BASE_PATH}/${normalizeModelDataUpdatesSection(section)}`;

const buildModelDataUpdatesLink = ({ section, updateId, contactId } = {}) => {
    const normalizedUpdateId = normalizeModelDataUpdatesParam(updateId);
    const normalizedContactId = normalizeModelDataUpdatesParam(contactId);
    const searchParams = new URLSearchParams();

    if (normalizedUpdateId) {
        searchParams.set('updateId', normalizedUpdateId);
    }

    if (normalizedContactId) {
        searchParams.set('contactId', normalizedContactId);
    }

    const queryString = searchParams.toString();
    const path = buildModelDataUpdatesSectionPath(section);

    return queryString ? `${path}?${queryString}` : path;
};

export {
    DEFAULT_MODEL_DATA_UPDATES_SECTION,
    MODEL_DATA_UPDATES_BASE_PATH,
    MODEL_DATA_UPDATES_PATH,
    MODEL_DATA_UPDATES_SECTIONS,
    buildModelDataUpdatesLink,
    buildModelDataUpdatesSectionPath,
    normalizeModelDataUpdatesParam,
    normalizeModelDataUpdatesSection,
};
